import {gql} from 'apollo-angular';
export const GET_STORY_QUIZ_QUESTION = gql`
  query getStoryQuizQuestion($gameId: Int!, $round: Int!) {
    getStoryQuizQuestion(gameID: $gameId, round: $round) {
      id
      text
      answers {
        id
        text
      }
      status {
        type
        message
      }
    }
  }
`;
